import React, { useCallback } from 'react';
import { View, InteractionManager, } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { rem } from 'design-system/values';
import { CardView, Spacer } from 'design-system';
import EmojiText from 'design-system/EmojiText';
import Text from 'design-system/Text';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { IconFatPlus } from 'design-system/icons';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { HEIGHT_PLUS_PADDING } from 'design-system/Button';
import useIsTablet from 'hooks/useIsTablet';
import { isDesktopOrWeb, isWeb } from '../../../../constants';
const PickSubcategoriesSection = ({ subcategories, parentCategory, selectedCategoryId, onPressCategory, hideAddNew, scrollRef, rowIndex, parentIndex, hasScreenMounted, }) => {
    const styles = useStyles(styleSet);
    const navigation = useMainStackNavigation();
    const onPressAddNew = useCallback(() => {
        navigation.navigateDeprecated('CreateCustomCategory', { parentCategory });
    }, [parentCategory]);
    const { deviceHeight } = useAppFrameDimensions();
    const { bottom } = useSafeAreaInsets();
    const onLayout = useCallback((e) => {
        if (isWeb || !hasScreenMounted)
            return;
        e.currentTarget.measureInWindow((_x, y, _width, cardHeight) => {
            const offset = deviceHeight - bottom - HEIGHT_PLUS_PADDING - cardHeight;
            if (offset < y || !cardHeight) {
                InteractionManager.runAfterInteractions(() => {
                    scrollRef.current?.scrollToIndex({
                        index: rowIndex,
                        viewPosition: 0.6,
                        animated: true,
                    });
                });
            }
        });
    }, [bottom, deviceHeight, hasScreenMounted, rowIndex, scrollRef]);
    const isTablet = useIsTablet();
    const { width } = useAppFrameDimensions(isWeb);
    return (<>
      <View style={styles.triangleRowContainer}>
        {Array.from({ length: 4 }).map((_, i) => (<View key={i} style={{
                width: isDesktopOrWeb || isTablet ? (width - rem(32)) / 4 : rem(76),
                alignItems: 'center',
            }}>
            {i === parentIndex && <View style={styles.triangle}/>}
          </View>))}
      </View>
      <CardView withPadding noMarginTop onLayout={onLayout}>
        <Text Text-16 Secondary>
          Subcategories
        </Text>
        <Spacer.H16 />
        <View style={styles.subcategories}>
          {subcategories.map((category) => {
            const { id, emoji, displayName } = category;
            const isSelected = selectedCategoryId === id;
            return (<TouchableBounce key={id} style={[styles.row, isSelected && styles.selectedButton]} onPress={() => onPressCategory(category)}>
                <EmojiText>{emoji || ''}</EmojiText>
                <Spacer.W8 />
                <Text Text-14 {...(isSelected ? { Primary: true } : {})}>
                  {displayName}
                </Text>
              </TouchableBounce>);
        })}
          {!hideAddNew && (<TouchableBounce style={styles.row} onPress={onPressAddNew}>
              <IconFatPlus colorKey="brand" width={20} height={20}/>
              <Spacer w={4}/>
              <Text Text-14>Add new</Text>
            </TouchableBounce>)}
        </View>
      </CardView>
    </>);
};
const styleSet = createStyleSheets((colors) => ({
    subcategories: {
        flexWrap: 'wrap',
        flexDirection: 'row',
        gap: rem(8),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingRight: rem(12),
        paddingLeft: rem(10),
        paddingVertical: rem(9),
        backgroundColor: colors.background.dark,
        borderRadius: rem(12),
        borderWidth: 1,
        borderColor: 'transparent',
    },
    selectedButton: {
        borderWidth: 1,
        borderColor: colors.elements.brand,
    },
    triangleRowContainer: {
        marginHorizontal: rem(16),
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    triangle: {
        width: 0,
        height: 0,
        borderLeftColor: 'transparent',
        borderLeftWidth: 6,
        borderRightColor: 'transparent',
        borderRightWidth: 6,
        borderBottomColor: colors.cards.onDark,
        borderBottomWidth: 10,
    },
}));
export default PickSubcategoriesSection;
